import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';
import LazyImage from './../LazyImage';
import BadgePlaceholder from './BadgePlaceholder'
import {
    teamNameValidation,
    setTeamName,
} from './../../actions/FormationActions';
import apiError from './../../constants/api-error';
import ProgressBar from './ProgressBar';
import Heading from './Heading';
import NextBtn from './NextBtn';
import config from './../../config';
import common from './../../common';
import AdBottom from '../AdBottom';

class GetTeamName extends Component {
    constructor(props) {
        super(props);
        const oldTeam = common.getDataFromCookie('LastSeasonTeamName');
        const teamName = this.props.teamName || oldTeam || '';
        this.state = {
            teamName: teamName,
            error: false,
            errorMsg: null,
            isDisabled: this.isDisabled(teamName)
        }
    }

    isDisabled = (value) => {
        return (value.length === 0) || (value.trim().length > config.MAX_TEAM_NAME_LENGTH) || (value.trim().length < config.MIN_TEAM_NAME_LENGTH);
    };
    handleChange = (event) => {
        const val = common.validateInput(event.target.value);
        this.setState({ teamName: val, isDisabled: this.isDisabled(val) });
        if (val == "") {
            this.props.setTeamName(null);
        }

    };
    handleNext = (e) => {
        e && e.preventDefault();
        // common.customTracking('Name Team');
        if (!this.state.isDisabled) {
            common.showLoader();
            this.props.callTeamNameValidation(this.state.teamName.trim()).then(() => {

                const teamNameValidationResponse = this.props.teamNameValidation.response;
                const retVal = teamNameValidationResponse.Meta['RetVal'];
                if (teamNameValidationResponse.Meta['Success'] && retVal === 1) {
                    this.props.setTeamName(this.state.teamName);
                    common.hideLoader();
                    // return this.props.history.push('/favourite-club');
                    setTimeout(() => {
                        return this.props.history.push('/save-team');
                    }, 100)

                } else {
                    common.hideLoader();
                    const message = apiError.updateTeamName[retVal];
                    this.setState({
                        error: true,
                        errorMsg: this.props.trans[message]
                    });
                }

            });
        }
    };

    render() {
        const badgeID = this.props.badgeID;
        if (!badgeID) {
            // return <Redirect push to={'/select-badge'} />
        }
        const wrapperClass = common.makeClasses({
            'si-main-component': true,
            'si-custom-team': true,
            'si-no-anim': true,
        });
        const isDisabled = this.state.isDisabled;
        let imgSrc = config.playerImgBase + `badges/${badgeID ? badgeID : 0}.png`;
        const inputClass = common.makeClasses({
            'si-error-border': this.state.error
        });
        return <div className={ wrapperClass }>
            <div className="si-container">
                <div className="si-top-section">
                    <ProgressBar />
                    <Heading title={ this.props.trans['name_your_team'] } { ...{ isDisabled } }
                        text={ this.props.trans.next }
                        showTitle={ isDisabled } tooltipText={ this.props.trans.select_your_teamName }
                        handler={ () => this.handleNext() } />
                </div>
                <div className="si-cust-container si-name-container si-flexBox">
                    {/* <div className="si-badge-wrap">
                        <div className="si-badge-img">
                            <LazyImage src={imgSrc} alt="" placeholder={<BadgePlaceholder />} />
                        </div>
                    </div> */}
                    <div className={ "si-team-name-txt" }>{ this.props.trans.youcannotChange ? this.props.trans.youcannotChange : "You cannot change your team name after the first matchday you play in" }</div>
                    <div className="si-team-name">
                        <form action="" onSubmit={ (e) => this.handleNext(e) }>
                            <input type="text" name="teamName" autoFocus autoComplete="off"
                                className={ inputClass }
                                placeholder={ this.props.trans['enter_team_name'] }
                                maxLength={ config.MAX_TEAM_NAME_LENGTH }
                                value={ this.state.teamName }
                                onChange={ (e) => this.handleChange(e) } />
                        </form>
                        { this.state.error ? <div className="si-error-msg">
                            <span>{ this.state.errorMsg }</span>
                        </div> : null }
                    </div>
                </div>
                <div className="si-btn-wrp  si-no-gradient">
                    <NextBtn { ...{ isDisabled } }
                        text={ this.props.trans.next }
                        showTitle={ isDisabled } tooltipText={ this.props.trans.select_your_teamName }
                        handler={ () => this.handleNext() } />
                </div>
                <AdBottom />
            </div>
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        badgeID: state.formationData.teamData.badgeID,
        teamName: state.formationData.teamData.teamName,
        teamNameValidation: state.formationData.teamNameValidation,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        setTeamName: (teamName) => dispatch(setTeamName(teamName)),
        callTeamNameValidation: (teamName) => dispatch(teamNameValidation(teamName)),
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GetTeamName));


// WEBPACK FOOTER //
// ./src/components/onboarding/GetTeamName.js